"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactKonva = require("react-konva");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HorizontalLines = function HorizontalLines(_ref) {
  var rectProps = _ref.rectProps,
      warningInfo = _ref.warningInfo,
      initWarning = _ref.initWarning,
      lineSelectedId = _ref.lineSelectedId,
      hLines = _ref.hLines,
      updateHLinesEnd = _ref.updateHLinesEnd,
      lineClick = _ref.lineClick;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showWarning = _useState2[0],
      setShowWarning = _useState2[1];

  var changeToCursor = function changeToCursor(e, cursorType) {
    e.target.getStage().container().style.cursor = cursorType;
  };

  (0, _react.useEffect)(function () {
    if (typeof warningInfo !== "undefined" && initWarning !== null) {
      setShowWarning(warningInfo["colourWarning"] || initWarning["colourWarning"]);
    } else if (typeof warningInfo === "undefined" && initWarning !== null) {
      setShowWarning(initWarning["colourWarning"]);
    } else if (typeof warningInfo !== "undefined" && initWarning === null) {
      setShowWarning(warningInfo["colourWarning"]);
    } else {
      setShowWarning(false);
    }
  }, [warningInfo, initWarning]);
  return hLines.map(function (line, i) {
    return /*#__PURE__*/_react.default.createElement(_reactKonva.Line, {
      key: i,
      x: rectProps.x,
      draggable: lineSelectedId === line.id,
      points: [0, 0, 0, 0, rectProps.width, 0],
      stroke: showWarning ? "#ffc107" : "#198038",
      opacity: lineSelectedId === line.id ? 0.8 : 0.3,
      strokeWidth: 4,
      onDragEnd: function onDragEnd(e) {
        // Updates the y coordinate for line
        var newHLines = hLines.slice();
        newHLines[i] = _objectSpread(_objectSpread({}, line), {}, {
          y: e.target.y(),
          yRectDist: e.target.y() - rectProps.y
        });
        updateHLinesEnd(newHLines);
      },
      onMouseOver: function onMouseOver(e) {
        return changeToCursor(e, "grab");
      },
      onMouseLeave: function onMouseLeave(e) {
        return changeToCursor(e, "default");
      },
      onDragMove: function onDragMove(e) {
        return changeToCursor(e, "grab");
      },
      y: line.y,
      id: line.id,
      onClick: function onClick(e) {
        return lineClick(line.id);
      },
      dragBoundFunc: function dragBoundFunc(pos) {
        // important pos - is absolute position of the node
        // you should return absolute position too
        return {
          x: this.absolutePosition().x,
          y: Math.min(rectProps.y + rectProps.height, Math.max(rectProps.y, pos.y))
        };
      }
    });
  });
};

var _default = HorizontalLines;
exports.default = _default;